import deviceConnectionService from '@/services/device/deviceConnectionService';
import appRouterService from '@/services/route/appRouterService';

const useForwardToUsbRequiredPage = ({deviceType}) => {
    const isBleConnectionSupported = deviceConnectionService.isBleConnectionSupported(deviceType);
    const isHidConnectionSupported = deviceConnectionService.isHidConnectionSupported(deviceType);
    const isUsbPageRequired = !isHidConnectionSupported && !isBleConnectionSupported;
    let redirect;

    if (isUsbPageRequired) {
        redirect = () => appRouterService.forwardToUsbRequiredPage(deviceType);
    }

    return {isUsbPageRequired, redirect};
};

export default useForwardToUsbRequiredPage;
